import styled from "styled-components";

export const NotificationCardWrapper = styled.div`
	padding-top: 150px;
	padding-bottom: 50px;
	display: flex;
	justify-content: center;
`;
export const NotificationCardContainer = styled.div`
	width: 70vw;
	// height: 200px;
	max-width: 1000px;
	background-color: #fff;
	border-radius: 10px;
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;

	@media screen and (max-width: 768px) {
		width: 90vw;
	}
`;

export const NotificationCardHeader = styled.div`
	box-sizing: border-box;
	width: 100%;
	padding: 1rem 1.75rem;
	border-bottom: 1px solid #f1f1f1;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 1.75rem;

	.header-content {
		// padding-left: 20px;
		display: flex;
		flex-direction: column;

		.title {
			font-size: 16px;
			font-weight: 600;
		}
		.sent-time {
			font-size: 14px;
			margin-top: 5px;
			color: #77798c;
		}
	}

	.icon {
		display: block;
		width: 80px;
		height: 80px;
		max-width: 80px;

		img {
			width: 100%;
			height: 100%;
      object-fit: contain;
		}
	}
`;

export const NotificationCardContent = styled.div`
	padding: 1.75rem;
`;

export const NotFoundContainer = styled.div`
	padding: 30px;
	p {
		text-align: center;
		font-size: 22px;
		font-weight: 600;
	}
`;
